/* istanbul ignore file */
export enum QueryParams {
  VillageId = "villageId",
  Tab = "tab",
  OccurrenceDate = "occurrenceDate",
  EditSeries = "editSeries",
  TemplateId = "templateId",
  type = "type",
  calendar = "calendar"
}
